<div class="st-filters-section">
  <div class="st-filters-section-header">
    <div class="title-section">
      <div class="k-input-wrapper">
        <span class="left-icon icon-magnifying-glass icon-light-color"></span>
        <input
          type="text"
          pInputText
          placeholder="Search"
          [(ngModel)]="searchModel"
          appDebounceInput
          (debouncedInput)="onSearch()" />
      </div>
    </div>
    <ng-content select="navigation-section"></ng-content>
    <div class="search-and-filter-toggle">
      <app-button
        class="show-filters-btn"
        [label]="filterToggleText()"
        [iconStart]="filterToggleIcon()"
        (btnClick)="showFilters()"
        [outlinedButton]="true"
        sizeClass="p-button-md"
        severity="primary">
      </app-button>

      <app-button
        class="show-filters-btn-sm"
        [label]="filterToggleText()"
        [iconStart]="filterToggleIcon()"
        (btnClick)="openFiltersDialog()"
        [outlinedButton]="true"
        sizeClass="p-button-md"
        severity="primary">
      </app-button>
    </div>
  </div>
  <div
    class="filters-containers"
    stCollapsible
    [isCollapsed]="!showFilter()">
    <app-filters-form
      [filterForm]="filterForm"
      [filterActionsPlacement]="filterActionsPlacement()"
      [filters]="filters()"
      [clearButtonText]="clearButtonText()"
      [ApplyButtonText]="ApplyButtonText()"
      (formSubmit)="submit()"
      (clearFilters)="clearFilters()"></app-filters-form>
  </div>
  @if (isApplied() && filterResults.length) {
    <div class="filters-result">
      @if (numberOfResults() > 0) {
        <div class="result-counter">
          <div class="result-counter-content">
            <span>{{ numberOfResults() }}</span
            ><span>{{ numberOfResults() === 1 ? "Result" : "Results" }}</span>
          </div>
        </div>
      }
      <div class="filters-result-items">
        @for (item of filterResults; track $index; let i = $index) {
          <div class="filters-result-item">
            <span class="label label-medium-regular text-caption-color capitalize">{{ item.label }}</span>
            <span class="value label-medium-regular text-caption-color capitalize">
              @if (item.valueLabel) {
                <span class="text">{{ item.valueLabel }}</span>
              } @else {
                <span class="text">{{ item.value }}</span>
              }
              <span
                (click)="removeSelectedFilter(item.moreInformation.controlName, i)"
                (keydown.enter)="removeSelectedFilter(item.moreInformation.controlName, i)">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none">
                  <path
                    d="M8.80864 3.20605L3.48657 8.52812"
                    stroke="#818EA1"
                    stroke-width="0.665259"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path
                    d="M3.48657 3.20605L8.80864 8.52812"
                    stroke="#818EA1"
                    stroke-width="0.665259"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </span>
            </span>
          </div>
        }
      </div>
      <div class="clear-section">
        <button (click)="clearResults()">Clear</button>
      </div>
    </div>
  }
</div>
